import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { VisionMissionComponent } from '../../home/vision-mission/vision-mission.component';
import { HomeDonorComponent } from '../../home/home-donor/home-donor.component';
import { HomeProjectComponent } from '../../home/home-project/home-project.component';

@Component({
  selector: 'app-about-details',
  standalone: true,
  imports: [CommonModule, RouterLink, VisionMissionComponent, HomeProjectComponent, HomeDonorComponent],
  templateUrl: './about-details.component.html',
  styleUrl: './about-details.component.scss'
})
export class AboutDetailsComponent {
  isToggled = false;
  about
  lang
  constructor(
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute, 
    private publicService: PublicServiceService, 
  ) {
     this.lang = Number(localStorage.getItem("language"))

      this.themeService.isToggled$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
  }

  toggleTheme() {
      this.themeService.toggleTheme();
  }

  ngOnInit(): void {
    this.getDat()
  }

  getDat() {
    this.publicService.getRecordList(this.publicService.ABOUT_URL, {"lang":this.lang?this.lang:1}).subscribe({
      next: (res) => {
        this.about = res
      },
      error: (err) => {
        console.log(err)
      }
    })
  }
}
